var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140.311,
    height: 140.311,
    viewBox: "0 0 140.311 140.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_check_boxes_re_v40f_1_",
    "data-name": "undraw_check_boxes_re_v40f (1)",
    transform: "translate(0 2.335)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_533",
    "data-name": "Ellipse 533",
    cx: 70.155,
    cy: 70.155,
    r: 70.155,
    transform: "translate(0 -2.335)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_534",
    "data-name": "Ellipse 534",
    cx: 58.463,
    cy: 58.463,
    r: 58.463,
    transform: "translate(11.693 9.358)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12906",
    "data-name": "Path 12906",
    d: "M324.487,279.886q-.157,0-.314-.008a6.419,6.419,0,0,1-4.759-2.473l-8.968-11.53a6.432,6.432,0,0,1,1.127-9.016l.323-.251a6.433,6.433,0,0,1,9.016,1.127,5.714,5.714,0,0,0,8.659.422l18.209-19.222a6.425,6.425,0,0,1,9.083-.245l.3.282a6.424,6.424,0,0,1,.245,9.082l-28.256,29.825A6.418,6.418,0,0,1,324.487,279.886Z",
    transform: "translate(-259.299 -190.924)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check_icon.0b708647e84d10f184695a754eb3e633.svg";
export { ForwardRef as ReactComponent };